export const THEME_NAME = "think12-theme";

export const getThink12Theme = (colors) => ({
  colors: colors,
});
